/* global gsap */
import { useRef, useEffect } from 'react';

export function useOpacityScroll(delta = 0.3) {
  const ref = useRef(null);

  useEffect(() => {
    function onScroll() {
      const opacity =
        (window.innerHeight - window.scrollY / delta) / window.innerHeight;

      if (opacity >= 0) {
        gsap.set(ref.current, { opacity });
      } else {
        gsap.set(ref.current, { opacity: 0 });
      }
    }

    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return ref;
}

export default {
  useOpacityScroll,
};
